module.exports = __webpack_public_path__ + "fonts/fontello.a782baa8.woff";